import React, {FC} from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemProps,
  ListItemText,
  Theme,
  Typography,
  TypographyVariant,
  useMediaQuery
} from '@mui/material';
import {SubText} from './PWMTypography';
import {SxProps} from '@mui/system';

export const PWMPropertyList: React.FC<IPWMPropertyListProps> = ({children, ...rest}) => {

  return (
    <List disablePadding {...rest}>
      {children}
    </List>
  );
};


interface IPWMPropertyListProps {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}

type Direction = 'horizontal' | 'vertical';

interface PropertyListItemProps extends ListItemProps {
  align?: Direction;
  small?: boolean;
  label: string | React.ReactNode;
  labelVariant?: TypographyVariant;
  value?: string;
  responsive?: boolean;
}

export const PWMPropertyListItem: FC<PropertyListItemProps> = (props) => {
  let {align = 'vertical', children, disableGutters, sx, small= true, labelVariant ="subtitle2", value, label, responsive = false, ...other} = props;
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  if(responsive){
    align = mdUp ? 'horizontal' : 'vertical';
  }
  return (
    <ListItem
      sx={{
        ...sx,
        px: disableGutters ? 0 : 3,
        py: small ? 0.5 : 1.5
      }}
      {...other}
    >
      <ListItemText
        disableTypography
        primary={(
          <Typography
            sx={{minWidth: align === 'vertical' ? 'inherit' : 180, marginRight: 1}}
            variant={labelVariant}
          >
            {label}
          </Typography>
        )}
        secondary={(
          <Box
            sx={{
              flex: 1,
              mt: align === 'vertical' ? 0.5 : 0
            }}
          >
            {children || (
              <SubText>
                {value}
              </SubText>
            )}
          </Box>
        )}
        sx={{
          display: 'flex',
          flexDirection: align === 'vertical' ? 'column' : 'row',
          my: 0
        }}
      />
    </ListItem>
  );
};
